import React from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';

import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  }
}));

const documents = [
  {name: 'ACORD GDPR'             , description: '', fileName: 'ACORD GDPR.pdf'             },
  {name: 'CHESTIONAR COVID-19'    , description: '', fileName: 'CHESTIONAR COVID-19.pdf'    },
  {name: 'FISA BITEST -TRIPLUTEST', description: '', fileName: 'FISA BITEST -TRIPLUTEST.pdf'}
];

export default function Documents(props) {
  const classes = useStyles();

  return (
    <Container maxWidth='sm'>
      <Typography variant='h5'>Formulare</Typography>
      <Typography color='textSecondary'></Typography>
      <Divider className={classes.divider} />

      <List>
        {documents.map(document =>
          <ListItem key={document.name}>
            <ListItemText
              primary={document.name}
              secondary={document.description}
            />
            <ListItemSecondaryAction>
                <IconButton color='primary' edge='end'
                  onClick={() => window.open(`${props.url.static}${document.fileName}`)}
                >
                  <GetAppIcon />
                </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        )}
      </List>
    </Container>
  );
}